import { CompatiblePluginEventType } from "roosterjs";
/**
 * RoosterScrollPreserverOnCopyPlugin
 *
 * This plugin handles clipboard copy events to prevent unwanted scroll position resets during copy operations.
 */ export class RoosterScrollPreserverOnCopyPlugin {
    /**
     * Get the name of this plugin
     */ getName() {
        return "RoosterScrollPreserverOnCopyPlugin";
    }
    /**
     * Initialize this plugin
     * @param editor The editor instance (required by EditorPlugin interface)
     */ initialize(editor) {
    // Editor instance not needed since we receive scroll container via setScrollContainer
    }
    /**
     * Set the scroll container element
     * @param container The scrollable container element
     */ setScrollContainer(container) {
        this.scrollContainer = container;
    }
    /**
     * Handle plugin events
     * @param event The plugin event
     */ onPluginEvent(event) {
        if (event.eventType === CompatiblePluginEventType.BeforeCutCopy) {
            this.captureScrollPosition();
            this.scheduleScrollRestore();
        }
    }
    /**
     * Dispose this plugin and clean up
     */ dispose() {
        this.scrollContainer = null;
    }
    /**
     * Capture the current scroll position
     */ captureScrollPosition() {
        if (this.scrollContainer) {
            this.savedScrollTop = this.scrollContainer.scrollTop;
        }
    }
    /**
     * Schedule scroll position restoration using requestAnimationFrame
     * to ensure restoration occurs after the copy operation completes
     */ scheduleScrollRestore() {
        requestAnimationFrame(()=>this.restoreScrollPosition());
    }
    /**
     * Restore the scroll position
     */ restoreScrollPosition() {
        if (this.scrollContainer) {
            this.scrollContainer.scrollTop = this.savedScrollTop;
        }
    }
    constructor(){
        this.savedScrollTop = 0;
        this.scrollContainer = null;
    }
}
